import CareCostHourly from '../dto/CareCostHourly';
import Deferred from '../polyfills';
import axios from 'axios';

window.careCostsCache = null;
window.deferredPromises = [];

export default class CareCostRepository {
    static findAll() {
        let deferred = new Deferred();

        if (window.deferredPromises.length > 0) {
            window.deferredPromises.push(deferred);

        } else if (!window.careCostsCache) {
            window.deferredPromises.push(deferred);

            axios
                .get('/care-costs/hourly')
                .then(response => {
                    window.careCostsCache = response.data.data.map(data => CareCostHourly.fromData(data));

                    let i;
                    for (i = window.deferredPromises.length; i--;) {
                        window.deferredPromises.shift().resolve(window.careCostsCache);
                    }

                })
                .catch(data => {
                    // couldn't load data
                    let i;
                    for (i = window.deferredPromises.length; i--;) {
                        window.deferredPromises.shift().reject(data);
                    }
                });
        } else {
            deferred.resolve(window.careCostsCache);

        }

        return deferred.promise;
    }
}
